import React, { useState, useEffect } from "react";
import { IconBrandSpotify } from "@tabler/icons-react";

interface SpotifyTrack {
  name: string;
  artist: string;
  albumImageUrl: string;
  songUrl: string;
  isPlaying: boolean;
}

const NowPlaying: React.FC = () => {
  const [track, setTrack] = useState<SpotifyTrack | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNowPlaying = async () => {
      try {
        const response = await fetch(
          "https://izzat.xyz/api/spotify/now-playing/v1",
        );

        if (response.status === 204 || !response.ok) {
          setTrack(null);
          return;
        }

        const data = await response.json();
        setTrack(data);
      } catch (error) {
        console.error("Error fetching now playing:", error);
        setTrack(null);
      } finally {
        setLoading(false);
      }
    };

    fetchNowPlaying();
    const interval = setInterval(fetchNowPlaying, 10000);

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="border border-amber-600 bg-amber-900/50 dark:border-gray-700 rounded-lg p-4 dark:bg-gray-900/50">
        <div className="flex items-center gap-2 mb-3">
          <IconBrandSpotify size={20} className="text-green-500" />
          <span className="text-sm font-medium text-amber-300 dark:text-gray-300">
            Now playing
          </span>
        </div>
        <div className="animate-pulse flex gap-3">
          <div className="w-16 h-16 bg-amber-800 dark:bg-gray-800 rounded"></div>
          <div className="flex-1">
            <div className="h-4 bg-amber-800 dark:bg-gray-800 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-amber-800 dark:bg-gray-800 rounded w-1/2"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!track || !track.isPlaying) {
    return (
      <div className="border border-amber-600 bg-amber-900/50 dark:border-gray-700 rounded-lg p-4 dark:bg-gray-900/50">
        <div className="flex items-center gap-2 mb-3">
          <IconBrandSpotify
            size={20}
            className="text-white dark:text-gray-500"
          />
          <span className="text-sm font-medium text-white dark:text-gray-400">
            Not playing
          </span>
        </div>
        <p className="text-xs text-white dark:text-gray-500">
          Currently not playing any songs on Spotify.
        </p>
      </div>
    );
  }

  return (
    <div className="border border-amber-600 bg-amber-900/50 dark:border-gray-700 rounded-lg p-4 dark:bg-gray-900/50 hover:bg-gray-900/70 transition-colors">
      <div className="flex items-center gap-2 mb-3">
        <IconBrandSpotify size={20} className="text-green-500" />
        <span className="text-sm font-medium text-white">Now playing</span>
        <div className="flex gap-0.5 ml-auto">
          <span className="w-0.5 h-3 bg-green-500 animate-pulse"></span>
          <span
            className="w-0.5 h-3 bg-green-500 animate-pulse"
            style={{ animationDelay: "0.2s" }}
          ></span>
          <span
            className="w-0.5 h-3 bg-green-500 animate-pulse"
            style={{ animationDelay: "0.4s" }}
          ></span>
        </div>
      </div>

      <a
        href={track.songUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex gap-3 group"
      >
        <img
          src={track.albumImageUrl}
          alt="Album art"
          className="w-16 h-16 rounded shadow-lg"
        />
        <div className="flex-1 min-w-0">
          <h3 className="text-white font-semibold text-sm truncate group-hover:text-green-500 transition-colors">
            {track.name}
          </h3>
          <p className="text-gray-400 text-xs truncate">{track.artist}</p>
        </div>
      </a>
    </div>
  );
};

export default NowPlaying;

//   if (loading) {
//     return (
//       <div className="border border-gray-700 rounded-lg p-4 bg-gray-900/50">
//         <div className="flex items-center gap-2 mb-3">
//           <IconBrandSpotify size={20} className="text-green-500" />
//           <span className="text-sm font-medium text-gray-300">Now playing</span>
//         </div>
//         <div className="animate-pulse flex gap-3">
//           <div className="w-16 h-16 bg-gray-800 rounded"></div>
//           <div className="flex-1">
//             <div className="h-4 bg-gray-800 rounded w-3/4 mb-2"></div>
//             <div className="h-3 bg-gray-800 rounded w-1/2"></div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!track || !track.isPlaying) {
//     return (
//       <div className="border border-gray-700 rounded-lg p-4 bg-gray-900/50">
//         <div className="flex items-center gap-2 mb-3">
//           <IconBrandSpotify size={20} className="text-gray-500" />
//           <span className="text-sm font-medium text-gray-400">Not playing</span>
//         </div>
//         <p className="text-xs text-gray-500">
//           No music currently playing on Spotify
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className="border border-gray-700 rounded-lg p-4 bg-gray-900/50 hover:bg-gray-900/70 transition-colors">
//       <div className="flex items-center gap-2 mb-3">
//         <IconBrandSpotify size={20} className="text-green-500" />
//         <span className="text-sm font-medium text-white">Now playing</span>
//         <div className="flex gap-0.5 ml-auto">
//           <span className="w-0.5 h-3 bg-green-500 animate-pulse"></span>
//           <span
//             className="w-0.5 h-3 bg-green-500 animate-pulse"
//             style={{ animationDelay: "0.2s" }}
//           ></span>
//           <span
//             className="w-0.5 h-3 bg-green-500 animate-pulse"
//             style={{ animationDelay: "0.4s" }}
//           ></span>
//         </div>
//       </div>

//       <a
//         href={track.songUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//         className="flex gap-3 group"
//       >
//         <img
//           src={track.albumImageUrl}
//           alt={track.album}
//           className="w-16 h-16 rounded shadow-lg"
//         />
//         <div className="flex-1 min-w-0">
//           <h3 className="text-white font-semibold text-sm truncate group-hover:text-green-500 transition-colors">
//             {track.name}
//           </h3>
//           <p className="text-gray-400 text-xs truncate">{track.artist}</p>
//         </div>
//       </a>
//     </div>
//   );
